import type { SVGProps } from 'react';
const SvgRotate90DegreesCcw = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#rotate_90_degrees_ccw_svg__a)">
      <path
        fill="currentColor"
        d="M7.34 6.41.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49ZM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66Zm15.67-6.26A8.95 8.95 0 0 0 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05a7.007 7.007 0 0 1 0 9.9 6.973 6.973 0 0 1-7.79 1.44l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64a8.98 8.98 0 0 0 0-12.72Z"
      />
    </g>
    <defs>
      <clipPath id="rotate_90_degrees_ccw_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgRotate90DegreesCcw;
